module.exports = __webpack_public_path__ + "static/media/NEO.a3e9d67e.svg";